import orderBy from 'lodash/orderBy';

export const agents = ({ items }) => orderBy(items, ['id'], ['desc'])
